/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint no-param-reassign: ["error", { "props": true, "ignorePropertyModificationsFor": ["state"] }] */
import disclaimersApiClient from '@/services/toolbox/disclaimers-service';
import { ERROR_DETAILS } from '../../constants/error-details';

const state = {
	list: [],
	testOutput: '',
	isEdited: false,
	disclaimerTextSelected: true,
	disclaimerText: [],
};

const mutations = {
	SET_LICENSE(state, { licenseId }) {
		state.disclaimerText = '';
		state.isEdited = true;
		state.list[licenseId].isSelected = !state.list[licenseId].isSelected;
	},

	SET_DISCLAIMERS_LICENSES(state, licenses) {
		state.list = licenses;
		state.disclaimerTextSelected = licenses.some(
			(el) => el.isSelected === true,
		);
	},

	TOGGLE_ALL_LICENSES(state, toggleValue) {
		state.isEdited = true;
		state.list.forEach((el) => {
			el.isSelected = toggleValue;
		});
	},

	SET_DISCLAIMER_PREVIEW_TEXT(state, { rootState, textValueArray }) {
		const selectedLicenseCount = state.list.filter(function (obj) {
			return obj.isSelected;
		}).length;
		const licenseRemovedViaTextDeletion =
			selectedLicenseCount !== textValueArray.length;

		state.isEdited = true;
		textValueArray.reverse(); // reverse the array so that we can match items to selected licenses then pop() them

		state.list.forEach((el) => {
			if (el.isSelected === true) {
				if (textValueArray.length > 0) {
					// Determine if license information has been modified
					if (el.disclaimerText != textValueArray[textValueArray.length - 1]) {
						// Determine if license should be deselected or its disclaimer text updated
						if (el.disclaimerText === '' && licenseRemovedViaTextDeletion) {
							el.isSelected = false;
						} else {
							el.disclaimerText = textValueArray[textValueArray.length - 1];
							textValueArray.pop();
						}
					} else {
						textValueArray.pop();
					}
				} else if (
					textValueArray.length == 0 &&
					licenseRemovedViaTextDeletion
				) {
					// Handles case to determine if last license of selected licenses should be deselected
					el.isSelected = false;
				}
			}
		});
	},

	LICENSES_ISEDITED(state, value = false) {
		state.isEdited = value;
	},

	SAVE_DISCLAIMER_LICENSES(state) {
		state.disclaimerTextSelected = state.list.some(
			(el) => el.isSelected === true,
		);
	},
};

const actions = {
	selectLicense({ commit, rootState }, licenseId) {
		commit('SET_LICENSE', { rootState, licenseId });
	},

	async getAllDisclaimerLicenses({ commit }, disclaimers) {
		commit('SET_DISCLAIMERS_LICENSES', disclaimers);
	},

	toggleAllLicenses({ commit, state }) {
		const toggleValue = !state.list.every((el) => el.isSelected === true);
		commit('TOGGLE_ALL_LICENSES', toggleValue);
	},

	setDisclaimerPreview({ commit, rootState }, event) {
		const textValueArray = event.target.value.split('\n');
		commit('SET_DISCLAIMER_PREVIEW_TEXT', { rootState, textValueArray });
	},
	async saveAllDisclaimerLicenses({ commit, dispatch, state }, contactId) {
		try {
			const { data } = await disclaimersApiClient.saveAllDisclaimerLicenses(
				contactId,
				state.list,
			);
			if (data === true) {
				commit('SAVE_DISCLAIMER_LICENSES');
				commit('LICENSES_ISEDITED', false);
				return true;
			} else {
				dispatch('showErrorModal', {
					errorDetails: ERROR_DETAILS.SAVE_CONTACT_DISCLAIMER,
				});
				return false;
			}
		} catch (error) {
			dispatch('showErrorModal', {
				errorDetails: ERROR_DETAILS.SAVE_CONTACT_DISCLAIMER,
			});
			return false;
		}
	},
};

export default {
	state,
	actions,
	mutations,
};
